module.exports = __webpack_public_path__ + "img/bg.2caf10de.jpg";